module.exports = __webpack_public_path__ + "img/section5_title.54c538da.png";